module.exports = __webpack_public_path__ + "images/e35ca55c705ba360642e036583decb48-VHLV Curio Logo Vertical.jpg";